import React from "react";

export const AppLoader = () => {
  return (
    <div className="loader-wrap">
      <div className="loader"></div>
    </div>
  );
}
